export const COLORS = {
  fire: "#edc2c4",
  steel: "#c2d4ce",
  dark: "#c6c5e3",
  ghost: "#d7c2d7",
  grass: "#c0d4c8",
  electric: "#e2e2a0",
  water: "#DEF3FD",
  ground: "#f4d1a6",
  rock: "#d5d5d4",
  fairy: "#e4c0cf",
  poison: "#cfb7ed",
  bug: "#c1e0c8",
  dragon: "#cadcdf",
  psychic: "#ddc0cf",
  ice: "#c7d7df",
  shadow: "#cacaca",
  unknown: "#c0dfdd",
  flying: "#b2d2e8",
  fighting: "#fcc1b0",
  normal: "#ddcbd0",
};
